import DataTable from 'datatables.net-dt'

export default () => {
    const tableElement = document.querySelector('.salesrep table.display') as HTMLTableElement;

    if (!tableElement) return;

    const table = new DataTable(tableElement, {
        order: tableElement.classList.contains('list-salers') ? [[0, 'asc']] : [[2, 'desc']],
        paging: true,
        pagingType: 'full_numbers',
        pageLength: 20,
        lengthChange: false,
        info: false,
        responsive: false,
        scrollX: true,
        select: true,
        scrollCollapse: tableElement.classList.contains('list-ambassador-salers'),
        scrollY: tableElement.classList.contains('list-ambassador-salers') ? '450px' : undefined,
        fixedColumns: tableElement.classList.contains('list-ambassador-salers') ? {leftColumns: 2} : undefined,
        language: {
            search: '',
            searchPlaceholder: 'Recherche par nom',
            emptyTable: "Vous n'avez encore rien ajouté.",
            zeroRecords: 'Pas de résultat pour cette recherche',
            paginate: {
                first: '<<',
                previous: '<',
                last: '>>',
                next: '>'
            }
        },
        initComplete: () => {
            const dataTablesFilter = document.querySelector('.dataTables_filter') as HTMLElement;

            if (tableElement.classList.contains('list-ambassador')) {
                const filterContent = `
          <div class="title"><p class="dynamic-title">Tous les ambassadeurs</p><p id="dynamic-title"></p></div>
          <div class="filter-project">
            <label for="project_type_filter" class="label-filter">Filtrer par :</label>
            <select id="project_type_filter" class="column_filter" data-column="5">
              <option value="">Type de projet</option>
              <option value="VÉRANDA">VÉRANDA</option>
              <option value="EXTENSION">EXTENSION</option>
              <option value="ABRI DE TERRASSE">ABRI DE TERRASSE</option>
              <option value="PERGOLA">PERGOLA</option>
              <option value="ABRI DE PISCINE">ABRI DE PISCINE</option>
              <option value="AUTRES">AUTRES</option>
            </select>
          </div>
          <a href="#" class="clear-filter">Réafficher la liste de tous les ambassadeurs</a>`;
                dataTablesFilter?.insertAdjacentHTML('afterbegin', filterContent);

                (tableElement.querySelector('thead > tr th:last-child') as HTMLElement)?.classList.remove('hidden');
                (tableElement.querySelectorAll('tbody > tr') as NodeListOf<HTMLTableRowElement>).forEach((tr) => {
                    tr.querySelector('td:last-child')?.classList.remove('hidden');
                });
            }

            if (tableElement.classList.contains('list-salers')) {
                const filterContent = '<div class="title"><p class="dynamic-title">Tous les commerciaux</p><p id="dynamic-title"></p></div>';
                dataTablesFilter?.insertAdjacentHTML('afterbegin', filterContent);
            }
            if (tableElement.classList.contains('visit')) {
                const filterContent = '<div class="title"><p>Total : ' + tableElement.getAttribute('data-visits') + ' visite(s)</p></div>';
                dataTablesFilter?.insertAdjacentHTML('afterbegin', filterContent);
            }
            if (tableElement.classList.contains('prospect')) {
                const filterContent = '<div class="title"><p>Total : ' + tableElement.getAttribute('data-prospects') + ' filleul(s)</p></div>';
                dataTablesFilter?.insertAdjacentHTML('afterbegin', filterContent);
            }

            const paginators = document.querySelectorAll('.dataTables_paginate') as NodeListOf<HTMLElement>;
            paginators.forEach((pagination) => {
                pagination.classList.add('pagination');
                if ((pagination.querySelectorAll('span a') as NodeListOf<HTMLAnchorElement>).length === 1) {
                    pagination.style.display = 'none';
                }
            });
        }
    });

    const numberOfRecords = (count: number, noFilter = true) => {
        const dynamicTitle = document.querySelector('.dynamic-title') as HTMLElement;
        if (tableElement.classList.contains('list-salers')) {
            dynamicTitle!.textContent = `${count} commercial${count > 1 ? 's' : ''} ${noFilter ? 'au total' : ''}`;
        } else if (tableElement.classList.contains('list-ambassador')) {
            dynamicTitle!.textContent = `${count} ambassadeur${count > 1 ? 's' : ''} ${noFilter ? 'au total' : ''}`;
        }
    };

    let count = table.rows().count();
    numberOfRecords(count);

    (document.querySelectorAll('select.column_filter') as NodeListOf<HTMLSelectElement>).forEach((select) => {
        select.addEventListener('change', function () {
            table.column(this.dataset.column!).search(this.value).draw();
        });
    });

    (document.querySelectorAll('a.clear-filter') as NodeListOf<HTMLAnchorElement>).forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const dynamicTitle = document.getElementById('dynamic-title');
            if (dynamicTitle) dynamicTitle.textContent = '';
            count = table.rows().count();
            numberOfRecords(count);
            table.search('').draw();
            document.querySelectorAll('.column_filter').forEach((filter) => (filter as HTMLSelectElement).value = '');
        });
    });

    (document.querySelectorAll('a.column_filter') as NodeListOf<HTMLAnchorElement>).forEach((filterLink) => {
        filterLink.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();

            const isActive = filterLink.classList.contains('active');
            document.querySelectorAll('.clear-filter').forEach((el) => el.classList.remove('active'));
            document.querySelectorAll('.bloc-details').forEach((el) => el.classList.remove('active'));
            document.querySelector('.home-ambassador')?.classList.add('collapse');

            document.querySelectorAll('.column_filter').forEach((filter) => {
                const column = (filter as HTMLElement).dataset.column;
                if (!column) return
                filter.classList.remove('active');
                table.column(column).search('').draw();
                (filter as HTMLSelectElement).value = '';
                document.getElementById('dynamic-title')!.textContent = '';
                const count = table.rows().count();
                numberOfRecords(count, false);
            });

            if (!isActive) {
                const column = filterLink.getAttribute('data-column');
                if (!column) return
                const value = filterLink.getAttribute('data-value');
                const search = table.column(column).search(value!);
                const count = table.page.info().recordsDisplay;
                search.draw();
                filterLink.classList.add('active');
                document.querySelectorAll('.clear-filter').forEach((el) => el.classList.add('active'));
                numberOfRecords(count, false);
                document.getElementById('dynamic-title')!.textContent = filterLink.getAttribute('data-text');
                document.getElementById(`bloc-${column}`)?.classList.add('active');
                document.querySelector('.home-ambassador')?.classList.remove('collapse');
            }

            const filterComments = document.querySelectorAll('.filter_comment');
            filterComments.forEach((comment) => comment.classList.remove('active'));
            filterComments.forEach((comment) => {
                const val = filterLink.getAttribute('data-value');
                if (comment.getAttribute('data-value') === val) {
                    comment.classList.add('active');
                }
            });
        });
    });

    document.getElementById('search-select')?.addEventListener('change', function () {
        table.search((this as HTMLSelectElement).value, true, false).draw();
    });

    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (target && target.id === 'clear-search') {
            table.search('').draw();
        }
    });

    document.getElementById('show_procedure')?.addEventListener('click', function (event) {
        event.preventDefault();
        const initialContent = document.getElementById('initial-content');
        const procedure = document.getElementById('procedure');
        if (initialContent?.classList.contains('active')) {
            initialContent.classList.remove('active');
            procedure?.classList.add('active');
            this.classList.add('active');
        } else if (procedure?.classList.contains('active')) {
            procedure.classList.remove('active');
            initialContent?.classList.add('active');
            this.classList.remove('active');
        }
    });

    document.getElementById('challengers-total')?.addEventListener('click', function () {
        this.classList.remove('off');
        document.getElementById('challengers-this-month')?.classList.remove('off');
        document.getElementById('challengers-this-month')?.classList.add('off');

        const topChallengersThisMonth = document.getElementById('top-challengers-this-month');
        const topChallengers = document.getElementById('top-challengers');
        topChallengersThisMonth?.classList.add('hidden');
        topChallengers?.classList.remove('hidden');
    });

    document.getElementById('challengers-this-month')?.addEventListener('click', function () {
        this.classList.remove('off');
        document.getElementById('challengers-total')?.classList.remove('off');
        document.getElementById('challengers-total')?.classList.add('off');

        const topChallengers = document.getElementById('top-challengers');
        const topChallengersThisMonth = document.getElementById('top-challengers-this-month');
        topChallengers?.classList.add('hidden');
        topChallengersThisMonth?.classList.remove('hidden');
    });

    document.querySelector('.export-salers')?.addEventListener('click', (event) => {
        event.preventDefault();
        const formData = new FormData();
        const projectTypeFilter = document.getElementById('project_type_filter') as HTMLSelectElement;
        const searchInput = document.querySelector('input[type="search"]') as HTMLInputElement;

        if (projectTypeFilter?.value) {
            formData.append('filter', projectTypeFilter.value);
        }

        if (searchInput?.value) {
            formData.append('search', searchInput.value);
        }

        document.location.href = `${document.location.origin}/ajax/export-ambassadors-salers?filter=${formData.get('filter')}&search=${formData.get('search')}`;
    });
}
